// Common
import ReactHtmlParser from 'react-html-parser';
import { decodeContractPercent } from '../../../../javascripts/filter_utils.js';
import ApartmentList from '../../apartment_list.js.jsx';
import ExpandableText from '../../expandable_text.js';
import { getDisplayedFoodAndTariff } from '../../filter_card_tariff.js';
import { IS_MIRTURBAZ, IS_SANATORIUMS } from '../../filter_main.js';
//

export default class DescriptionLeft extends React.Component {
  constructor(props) {
    super(props);
    this.seo_path_with_params = this.seo_path_with_params.bind(this);
    this.isRecommended = this.isRecommended.bind(this);
    this.campPercent = this.campPercent.bind(this);
    this.campCommission = this.campCommission.bind(this);
    this.campIntegrations = this.campIntegrations.bind(this);
    this.showMapCamp = this.showMapCamp.bind(this);
    this.locationItem = this.locationItem.bind(this);
    this.locationClicked = this.locationClicked.bind(this);
    this.web_site_item = this.web_site_item.bind(this);
    this.render_tag = this.render_tag.bind(this);
    this.recommended_tags = this.recommended_tags.bind(this);
    this.instant_booking = this.instant_booking.bind(this);
    this.not_required_prepayment = this.not_required_prepayment.bind(this);
    this.free_cancellation = this.free_cancellation.bind(this);
    this.foodTypeName = this.foodTypeName.bind(this);
    this.distanceFromPlace = this.distanceFromPlace.bind(this);
    this.renderTariff = this.renderTariff.bind(this);
    this.constructionBlock = this.constructionBlock.bind(this);
    this.campWithRewardLabel = this.campWithRewardLabel.bind(this);
    this.topTagBlock = this.topTagBlock.bind(this);
    this.bottomTagBlock = this.bottomTagBlock.bind(this);
    this.renderTagBlock = this.renderTagBlock.bind(this);
    this.tagBlockContent = this.tagBlockContent.bind(this);
    this.formatTagList = this.formatTagList.bind(this);
  }

  seo_path_with_params() {
    let seo_path_with_params = this.props.data.seo_path;
    if (this.props.filter_params.url_str) seo_path_with_params += `?${this.props.filter_params.url_str}`;
    return seo_path_with_params;
  }

  isRecommended() {
    if (this.props.data.is_recommended) {
      return (
        <div
          className='icon icon-type_like icon-type_like-dims card__sign-ico'
          title='Мы рекомендуем данную базу отдыха, основываясь на качестве услуг, доступных ценах и положительных отзывах предыдущих гостей.'
        ></div>
      );
    }
  }

  campMarkup() {
    if (this.props.showContractPercent) {
      const markup = this.props.data.min_apartment_price_markup;
      if (!markup || markup === 0) return;
      return (
        <span className='card__markup' title={`Объект работает только по ценам с наценкой. Размер наценки: ${markup}%`}>
          {`Наценка ${markup}%`}
        </span>
      );
    }
  }

  campCommission() {
    if (!this.props.showCommission) return;

    const little = this.props.data.commission_in_little_period;
    const big = this.props.data.commission_in_big_period;
    const source = this.props.data.commission_source;
    const label = source ? `${source} ` : '';

    return `${label}hy: ${little} y: ${big}`;
  }

  campPercent() {
    const percent = decodeContractPercent(this.props.data.a2);
    if (!this.props.showContractPercent || percent == null) return;

    return (
      <span className='card__percent' title={this.campCommission()}>
        {percent + '%'}
      </span>
    );
  }

  sortWeight() {
    if (!this.props.showContractPercent) return;

    const debug = this.props.data.sort_weight_debug;
    if (!debug) return;

    const line = (part) => `${part.label}: ${part.value} (${part.source})`;
    const title = [
      `${debug.project_column}: ${debug.project_weight}`,
      ...(debug.formula || []).map(line),
      ...(debug.boosts || []).map(line),
      `итого: ${debug.total}`
    ].join('\n');

    return (
      <span className='card__percent' title={title}>
        {debug.total}
      </span>
    );
  }

  campConflict() {
    if (this.props.data.show_conflict_label) {
      return (
        <span className={'btn-warning info-box_conflict'}>
          <span className={'info-box_conflict__text'} title={this.props.data.conflict_notes}>
            Конфликт
          </span>
        </span>
      );
    }
  }

  campIntegrations() {
    if (this.props.showContractPercent) {
      return <span dangerouslySetInnerHTML={{ __html: this.props.data.camp_integrations }}></span>;
    }
  }

  showMapCamp() {
    this.props.showMapCamp(this.props.data);
  }

  distanceFromPlace() {
    const atGreaterDistance = this.props.nearbyCamps?.some((camp) => camp.id === this.props.data.id);

    if (atGreaterDistance && this.props.data.distance_to_city) {
      return (
        <li className='card__contact-item card__contact-item_grow text_gray'>
          <div className='fas fa-location-arrow' aria-hidden='true'></div>
          <span
            className='card__contact-item-link text_gray under under_dot_gray'
            title={`Указано прямое расстояние до центра ${this.props.filter_params.city_name_genitive}. Реальное расстояние в пути может быть больше.`}
          >
            До {this.props.filter_params.city_name_genitive} {this.props.data.distance_to_city.toFixed(2)} км
          </span>
        </li>
      );
    }
  }

  locationItem() {
    return (
      <li className='card__contact-item card__contact-item_grow'>
        <div className='card__contact-item-icon icon icon-marker_gray icon-marker_gray-dims'></div>
        <a className='card__contact-item-link text_gray underline_dashed' onClick={this.locationClicked}>
          {this.props.data.location}
        </a>
      </li>
    );
  }

  distance_item() {
    let distanceCampToItem = this.distanceCampToItem();

    if (distanceCampToItem != null) {
      return (
        <li className='card__contact-item card__contact-item_grow'>
          <div className='card__contact-item-icon icon icon-ze-wave icon-ze-wave-dims' />
          <div className='card__contact-item-link text_gray underline_dashed'>{distanceCampToItem}</div>
        </li>
      );
    }
  }

  locationClicked() {
    this.showMapCamp();
    window.ymReachGoal('filter:camp-card:map');
  }

  web_site_item() {
    if (this.props.data.web_site !== '') {
      return (
        <li className='card__contact-item'>
          <div className='card__contact-item-icon icon icon-earth-ico icon-earth-ico-dims'></div>
          <a
            href={this.props.data.web_site}
            className='card__contact-item-link link before-ico before-ico_arrow before-ico_arrow_min'
            target='_blank'
          >
            Официальный сайт
          </a>
        </li>
      );
    }
  }

  render_tag(tag) {
    return (
      <a
        href={`${window.website_prefix}${tag.url}`}
        className='card__labels-item card__labels-item_recomend'
        target='_self'
        key={tag.id}
      >
        {tag.name}
      </a>
    );
  }

  recommended_tags() {
    if (this.props.apartments.apartments.length !== 0) {
      return this.props.data.recommended_tags.map(this.render_tag);
    }
  }

  instant_booking() {
    if (this.props.selectedTariff?.instant_booking) {
      return (
        <a
          className='card__labels-item card__labels-item_ico card__labels-item_submit'
          title='У данной базы отдыха есть возможность бронирования с моментальным подтверждением.
                 Просто выберите подходящий вариант проживания, оплатите заказ и получите свой ваучер'
        >
          <div className='icon icon-flash_blue icon-flash_blue-dims'></div>
          <span>Моментальное подтверждение</span>
        </a>
      );
    }
  }

  not_required_prepayment() {
    if (this.props.selectedTariff?.not_required_prepayment) {
      return (
        <a className='card__labels-item card__labels-item_ico card__labels-item_demand'>
          <div className='icon icon-cash'></div>
          <span className={'card__labels__text'}>Оплата при заселении</span>
        </a>
      );
    }
  }

  free_cancellation() {
    if (this.props.data.is_free_cancellation) {
      return (
        <a
          className='card__labels-item card__labels-item_ico card__labels-item_cancel'
          title='Бесплатная отмена не позднее установленного срока. В случае отмены позднее взымается штраф. Подробнее на странице объекта размещения'
        >
          <div className='icon icon-arrow-back-green icon-arrow-back-green-dims'></div>
          <span>Бесплатная отмена</span>
        </a>
      );
    }
  }

  foodTypeName() {
    const { count_guests, delta_days } = this.props;
    const validSearch = delta_days && count_guests;
    if (!validSearch) return null;

    const tariffName = this.props.tariffCondition;
    const foodName = this.props.food_type_name;

    if (tariffName || foodName) {
      return (
        <li className='card__desc-info-list-item_tariff_food card__desc-width'>
          {tariffName ? <span className='card__desc-info-list-item_tariff'>{tariffName}</span> : null}
          {foodName ? <span className='card__desc-info-list-item_food'>{foodName}</span> : null}
        </li>
      );
    }
  }

  distanceCampToItem() {
    if (IS_SANATORIUMS) return null;
    if (this.props.data.waters_distances.length > 0) {
      return (
        <span>
          {this.props.data.waters_distances[0].value} м до {this.props.data.waters_distances[0].river_name}
        </span>
      );
    }
  }

  treatmentProfiles() {
    const profilesList = this.formatTagList(this.props.data.treatment_profiles_services);

    if (!profilesList) return;

    return (
      <div className='card__treatmentProfile'>
        <div className='card__treatmentProfile-icon'></div>
        <ExpandableText text={profilesList} className='card__treatmentProfile-text' />
      </div>
    );
  }

  treatmentServiceTags() {
    if (!IS_SANATORIUMS) return null;

    const serviceTagList = this.formatTagList(this.props.data.treatment_service_tags);

    if (!serviceTagList) return;

    return (
      <div className='card__treatmentServiceTags'>
        <div className='card__treatmentServiceTags-icon'></div>
        <ExpandableText text={serviceTagList} className='card__treatmentServiceTags-text' />
      </div>
    );
  }

  formatTagList(items) {
    return items?.map((item, i) => (i > 0 ? item.name.toLowerCase() : item.name))?.join(', ');
  }

  renderTariff() {
    const { apartments, food_type_name, tariffCondition, count_guests, delta_days } = this.props;
    const apartment = apartments.apartments[0];
    const { foodName: foodTypeName, tariffName } = getDisplayedFoodAndTariff({
      apartment,
      selectedTariff: this.props.selectedTariff,
      foodTypeName: food_type_name,
      tariffCondition,
      delta_days,
      count_guests,
      tariffSource: this.props.selectedTariff?.tariff_source,
    });

    if (foodTypeName || tariffName) {
      return (
        <li className={`card__desc-info-list-item_tariff_food card__desc-width`}>
          {tariffName ? <span className='card__desc-info-list-item_tariff'>{tariffName}</span> : null}
          {foodTypeName ? <span className='card__desc-info-list-item_food'>{foodTypeName}</span> : null}
        </li>
      );
    }
  }

  constructionBlock() {
    const { filter_values, data } = this.props;
    const { reconstruction_year, foundation_year } = data;

    if (filter_values?.sort.type !== 'newness' || (!reconstruction_year && !foundation_year)) return;

    const iconClass = foundation_year ? 'foundation-icon' : 'reconstruction-icon';
    const textParts = [];

    if (foundation_year) textParts.push(`Открытие в ${foundation_year}`);
    if (reconstruction_year) textParts.push(`Реконструкция в ${reconstruction_year}`);

    return (
      <div className='card__construction-history'>
        <div className={`card__construction-history-icon ${iconClass}`}></div>
        <div className='card__construction-history-text'>{textParts.join(' · ')}</div>
      </div>
    );
  }

  campWithRewardLabel() {
    const { increased_reward_label: increasedRewardLabel } = this.props.data;
    if (!increasedRewardLabel) return;

    return (
      <div className='card__labels-row'>
        <a className='card__labels-item card__labels-item_reward' title={increasedRewardLabel.description}>
          <span>{increasedRewardLabel.title}</span>
        </a>
      </div>
    );
  }
  topTagBlock() {
    const { seo_page } = this.props.filter_params;
    if (!seo_page) return null;
    return this.renderTagBlock(seo_page.display_options[0], 'first');
  }

  bottomTagBlock() {
    const { seo_page } = this.props.filter_params;
    if (!seo_page) return null;
    return this.renderTagBlock(seo_page.display_options[1], 'second');
  }

  renderTagBlock(option, groupKey) {
    const optionHandlers = {
      service: () => this.tagBlockContent(groupKey),
      healing_factors: () => this.treatmentProfiles(),
      opening_date: () => this.constructionBlock(),
      all_baths: () => this.tagBlockContent(groupKey),
      default: () => '',
    };

    return optionHandlers[option] ? optionHandlers[option]() : optionHandlers.default();
  }

  tagBlockContent(groupKey) {
    const { data, filter_params } = this.props;
    const properties = data[`properties_from_${groupKey}_group`];
    const iconClass = filter_params[`${groupKey}_group_icon_class`];
    if (properties?.length < 1) return null;
    return (
      <div className='card__pool'>
        {iconClass && <div className={`card__pool-icon mt_svg_service_icon mt_svg_service_icon-${iconClass}`}></div>}
        <div className='card__pool-text'>{properties}</div>
      </div>
    );
  }

  render() {
    const treatmentProfiles = this.treatmentProfiles();
    const constructionBlock = this.constructionBlock();
    const topTagBlock = this.topTagBlock();
    const bottomTagBlock = this.bottomTagBlock();
    const { min_price, campsLoaded, show_all_camps, count_guests, delta_days } = this.props;
    const validSearch = delta_days && count_guests;
    const movedTariffToApartmentList = IS_MIRTURBAZ && !validSearch;
    const apartmentListOwnsTariffDetails = Boolean(this.props.data?.complex_placement);
    const treatmentServiceTags = this.treatmentServiceTags();

    return (
      <div className='card__desc-left'>
        <a
          href={this.seo_path_with_params()}
          className='camp_link'
          target='_blank'
          rel={this.props.is_nofollow ? 'nofollow' : null}
        >
          <h3 className='card__title'>
            {this.props.data.full_name} {ReactHtmlParser(this.props.data.stars_inline)}
            {this.isRecommended()}
            {this.campPercent()}
            {this.sortWeight()}
            {this.campMarkup()}
            {this.campIntegrations()}
            {this.campConflict()}
          </h3>
        </a>
        <ul
          className={
            !treatmentProfiles && !constructionBlock && !(topTagBlock || bottomTagBlock || treatmentServiceTags)
              ? 'card__contact'
              : ''
          }
        >
          {this.locationItem()}
          {this.distance_item()}
          {this.distanceFromPlace()}
          {this.web_site_item()}
        </ul>
        <div className={'card__info'}>
          {treatmentServiceTags}
          {topTagBlock}
          {bottomTagBlock}
        </div>
        <div className='card__labels'>
          <div className='card__labels-row'>
            {/*{this.recommended_tags()}*/}
            {this.free_cancellation()}
          </div>

          {((show_all_camps && campsLoaded && min_price) || !show_all_camps) && (
            <div className='card__labels-row'>
              {this.not_required_prepayment()}
              {this.instant_booking()}
            </div>
          )}

          {this.campWithRewardLabel()}
        </div>
        <div className='card__desc-bot-info'>
          {this.props.show_all_camps && !this.props.campsLoaded ? (
            <ul className='card__desc-info-list'>
              <li className='card__desc-bot-info'>
                <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>

                <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>

                <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
              </li>
            </ul>
          ) : (
            <ul className='card__desc-info-list'>
              <ApartmentList
                {...this.props.apartments}
                is_nofollow={this.props.is_nofollow}
                food_type_name={this.props.food_type_name}
                tariffCondition={this.props.tariffCondition}
                showAllCamps={this.props.show_all_camps}
                campsLoaded={this.props.campsLoaded}
                renderTariff={this.renderTariff}
                movedTariffToApartmentList={movedTariffToApartmentList}
              />
              {!movedTariffToApartmentList &&
                !apartmentListOwnsTariffDetails &&
                (!IS_MIRTURBAZ ? this.renderTariff() : this.foodTypeName())}
            </ul>
          )}
        </div>
      </div>
    );
  }
}
